import { FC } from 'react';
import Interview from 'types/Interview';
import { getLocaleDate, getLocaleTime } from 'utils/time';
import { Container } from './components';

type Props = {
  interview: Interview | undefined;
};
const NoAnswer: FC<Props> = ({ interview }) => {
  return (
    <Container>
      <p>
        Le mentor a proposé un entretien le{' '}
        {interview?.date && getLocaleDate(interview.date)} à{' '}
        {interview?.date && getLocaleTime(interview.date)}, mais le mentoré n'a
        pas répondu dans les temps.
      </p>
    </Container>
  );
};

export default NoAnswer;
